export const componentIds = {
  ChartLine: 'ChartLine',
};
